<template>
  <div id="app">
    <!-- Loader -->
    <div id="preloader" v-if="loading" v-responsive.lg.xl >
      <div id="status">
        <div class="spinner"></div>
      </div>
    </div>
    <div id="preloader" v-if="loading" v-responsive.sm.xs >
      <div id="status-mobile">
        <div class="spinner"></div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>

export default {
  data() {
    return {
      loading: false
    };
  },
  created() {
    setTimeout(() => (this.loading = false), 600);
  }
};
</script>
<style>
body {
  background-color: #fbfafd!important;
  margin-top: env(safe-area-inset-top);
  margin-top: constant(safe-area-inset-top);
}

ion-tab-bar {
  margin-bottom: env(safe-area-inset-bottom);
}
</style>